
const resource_drawers = (()=>{
    'use strict';
    const Params = {
        'open_class': 'expanded'
    };
    const Methods = {
        toggle(e) {
            if (!e || typeof e != 'object' || typeof e.currentTarget == 'undefined') { return; }
            const panel_id = seismicUtilities.scrub( e.currentTarget.getAttribute('aria-controls') );
            if (!panel_id || panel_id == '') { return; }
            const panel = document.getElementById(panel_id);
            if (!panel) { return; }
            if (e.currentTarget.getAttribute('aria-expanded') == 'false') {
                panel.classList.add(Params.open_class)
                panel.style.maxHeight = panel.scrollHeight +'px';
                e.currentTarget.setAttribute('aria-expanded', 'true');
            } else {
                panel.style.maxHeight = null;
                panel.classList.remove(Params.open_class)
                e.currentTarget.setAttribute('aria-expanded', 'false');
            }
        },
        init() {
            const buttons = document.querySelectorAll('.resource-drawers button.toggle');
            if (!buttons.length) { return; }
            for (let i=0, len=buttons.length; i<len; i++) {
                buttons[i].addEventListener('click', (e)=>{ resource_drawers.toggle(e) })
            }
            /* now check for a relevant hash in the URL */
            const hash = seismicUtilities.scrub( window.location.hash.split('#')[1] );
            if ( hash && hash != '' ) {
                const panel_button = document.getElementById(hash +'-toggle');
                if (panel_button) { 
                    panel_button.click();
                }
            }
        }
    };
    return Methods;
})();
document.addEventListener('DOMContentLoaded',()=>{
    resource_drawers.init()
});